export default __webpack_public_path__ + "static/media/socialMedia.060e1cfa.svg";